import en from './EN'
import zh from './CN'
import ko from './KO'
import ja from './JA'
import ru from './RU'
import vn from './VN'

import es from './ES'
import fr from './FR'
import de from './DE'
import tr from './TR'

export default {
  en,
  zh,
  ko,
  ja,
  ru,
  vn,
  
  es,
  fr,
  de,
  tr
}